import { scenePlugins } from '@ff-os/pdp-shared-registry/index';
import { PdpState, PdpStore } from './store';

type Status = 'pending' | 'error' | 'ready';

export class ExportMonitor<TProject> {

    constructor(
        readonly store: PdpStore<TProject>,
        readonly getStatus: (state: PdpState<TProject>) => Status
    ) { }

    promise = async () => {

        return new Promise<TProject>((resolve, reject) => {

            const unsubscribe = this.store.subscribe(() => {
                update();
            });

            const update = () => {
                const state = this.store.getState();
                const status = this.getStatus(state);
                if (status === 'ready') {
                    resolve(state.project);
                    unsubscribe();
                } else if (status === 'error') {
                    reject();
                    unsubscribe();
                }
            };

            update();
        });
    };
}

let exportMonitor: ExportMonitor<unknown>;

export const initializeExportMonitor = (store: PdpStore) => {
    const state = store.getState();
    const plugin = scenePlugins.require(state.scene.pluginId);
    exportMonitor = new ExportMonitor(store, plugin.project.getExportStatus);
};

export const exportProject = async () => {
    return await exportMonitor.promise();
};